<template>
    <div class="containerShadowN">
        <v-btn :disabled="loadingSavePatient" class="close" @click.prevent="closeEl">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </v-btn>
        <div class="createPatient">
            <div class="createPatient-header">
                <h1>{{ getFlagEditePatientOrNot ? 'Редактирование' : 'Создать' }} пациента</h1>
                <div class="header_name-container">
                    <div class="name-icon">

                        <div v-if="!newPatient.logoUrl" class="icon" @click="setCroppFlag(true)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="58" height="52" viewBox="0 0 58 52" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M44.2577 12.689V12.689C43.2482 12.689 42.3334 12.1037 41.9031 11.189C41.1264 9.5339 40.1385 7.41873 39.5539 6.26723C38.6906 4.55495 37.2914 3.55862 35.3536 3.54501C35.3211 3.54229 22.6769 3.54229 22.6444 3.54501C20.7066 3.55862 19.3101 4.55495 18.4441 6.26723C17.8622 7.41873 16.8743 9.5339 16.0976 11.189C15.6673 12.1037 14.7498 12.689 13.7431 12.689V12.689C8.34108 12.689 3.96484 17.0908 3.96484 22.5216V38.6807C3.96484 44.1088 8.34108 48.5134 13.7431 48.5134H44.2577C49.6569 48.5134 54.0332 44.1088 54.0332 38.6807V22.5216C54.0332 17.0908 49.6569 12.689 44.2577 12.689Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.3968 29.6328C20.3941 34.4049 24.2669 38.3085 29.0031 38.3058C33.7312 38.3004 37.5932 34.413 37.6013 29.6519C37.6094 24.8717 33.7501 20.9762 29.0085 20.9707C24.2398 20.9653 20.3589 24.9261 20.3968 29.6328Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M42.2668 23.2651C42.0053 23.2381 41.747 23.1694 41.4578 23.0523C41.136 22.9086 40.8575 22.7257 40.5882 22.4505C40.1044 21.9328 39.8242 21.2559 39.8242 20.5575C39.8242 20.1866 39.8996 19.8189 40.0469 19.4859C40.1944 19.1484 40.3693 18.8638 40.6853 18.5542C40.9257 18.3435 41.172 18.1741 41.5087 18.0249C42.5071 17.627 43.6946 17.8647 44.4368 18.6109C44.6593 18.8314 44.8466 19.0974 44.9505 19.3217L45.0121 19.4808C45.1616 19.8189 45.237 20.1866 45.237 20.5575C45.237 21.27 44.9605 21.929 44.4471 22.4775C44.0034 22.9267 43.4207 23.203 42.7991 23.2651L42.5306 23.2784L42.2668 23.2651Z" fill="white"/>
                            </svg>
                            <span>Добавить фото</span>
                        </div>

                        <img @click="setCroppFlag(true)" v-if="newPatient.logoUrl" :src="apiImg + newPatient.logoUrl" alt="" class="add-files_form_img_cropp">
                    </div>
                    <div class="name">
                        <p>ФИО*</p>
                        <input :class="{ 'errorFio': errorFio }" v-model="newPatient.fio" type="text" name="patientName" id="patientName" placeholder="Введите текст">
                    </div>
                </div>
            </div>
            <div class="createPatient-info">
                <div class="gender-container">
                    <p>Пол*</p>
                    <v-combobox
                        hide-details
                        label=""
                        :items="genderList"
                        variant="outlined"
                        class="profile_org"
                        v-model="newPatient.gender"
                        :width="100 + '%'"
                        :class="{ 'profile_org_error': errorGender }"
                    />
                </div>
                <div class="birthday-container">
                    <p>Дата рождения*</p>
                    <v-menu class="addTask_combo-time" fir v-model="menu" ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-on="on"
                                v-bind="attrs"
                                placeholder="__.__.____"
                                readonly
                                :value="returnBirthday"
                                single-line
                                hide-details="auto"
                                height="44px"
                                :style="errorBirthday ? 'border: 1px solid red; border-radius: 9px;' : ''"
                                :error="errorBirthday"
                            />
                        </template>
                        <v-date-picker
                            v-model="newPatient.birthday"
                            :first-day-of-week="1"
                            :active-picker.sync="activePicker"
                            no-title
                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                            min="1950-01-01"
                            @change="$refs.menu.save(newPatient.birthday)"
                        />
                    </v-menu>
                </div>
            </div>
            <div class="createPatient-anamnesis">
                <p>Анамнез жизни</p>
                <v-container fluid class="pl-0 pr-0">
                    <v-textarea
                        no-resize
                        outlined
                        label=""
                        :rules="[rules.maxSymbol]"
                        v-model="newPatient.anamnesTxt"
                    />
                </v-container>
            </div>
            <div class="createPatient-anamnesisFamily">
                <p>Семейный анамнез</p>
                <button @click="dialog = true">+ Добавить семейный анамнез</button>

                <v-data-table
                    :headers="headers"
                    :items="newPatient.anamnesis"
                    hide-default-footer
                    class="elevation-1 custom-table"
                    :items-per-page="-1"
                    loading-text="Данные подгружаются..."
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn icon small @click="editeItems(item)" color="primary">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                    </template>

                    <template v-slot:[`item.relations`]="{ item }">
                        {{ item.relations.length > 0 ? item.relations.map((m) => m.relationName).join(', ') : '' }}
                    </template>
                </v-data-table>


                <div class="live_episods">
                    <p>Эпизоды жизни </p>
                    <button :disabled="newPatient.id ? false : true" :class="{'btnDisable': newPatient.id ? false : true}" @click="showAdd">
                        + Добавить эпизод
                    </button>
                    <ul class="episods_list">
                        <li class="item" v-for="(el, idx) in newPatient.episodes" :key="'M'+idx">
                            <div class="d-flex align-center">
                                <span>{{ el.name }}</span>
                                <v-btn :loading="el.editeFlag" icon small @click="editeEpisode(el)" color="primary">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn :loading="deleteEpisodeLoading" @click="deleteEpisode(el)"  class="ml-2 deleteBtn" style="border: 2px solid red !important;" icon small color="error">
                                    <v-icon color="error" small>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="createPatient-footer">
                <v-btn :disabled="loadingSavePatient" type="button" @click="closeEl">Отменить</v-btn>
                <v-btn :loading="loadingSavePatient" type="button" @click="saveAllPatient(newPatient)">Сохранить</v-btn>
            </div>
        </div>


        <v-dialog v-model="dialog" max-width="900px" persistent>
			<v-card>
				<v-card-text class="pb-0">
					<v-container>
						<v-form ref="formGroup" v-model="valid" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<div class="gender-container">
                                        <p>Степень родства</p>
                                        <v-autocomplete
                                            multiple
                                            label=""
                                            dense
                                            :items="listDegreeOfKinship"
                                            item-text="name"
                                            :rules="[rules.requiredMultiple]"
                                            item-value="id"
                                            return-object
                                            outlined
                                            class="profile_org"
                                            v-model="objNewAnamnesisFamily.degreeOfKinship"
                                        />
                                    </div>
								</v-col>
								<v-col cols="12" sm="12" md="12">
									<div class="gender-container">
                                        <p>Заболевание</p>
                                        <v-autocomplete
                                            label=""
                                            dense
                                            :items="listDisease"
                                            :rules="[rules.required]"
                                            return-object
                                            item-text="codeName"
                                            item-value="id"
                                            outlined
                                            class="profile_org"
                                            v-model="objNewAnamnesisFamily.disease"
                                        />
                                    </div>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn @click="close" color="blue darken-1" dark>Отмена</v-btn>
					<v-btn color="success" @click="saveAnamnesisFam(objNewAnamnesisFamily)" dark>Сохранить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

        <v-dialog v-model="getCroppFlag" max-width="700px" persistent>
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <advanced-cropp @submit="handleImageUpload" url="Patient/UploadLogo" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
		</v-dialog>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import "./index.scss"
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import AddEpisodeLife from '../AddEpisodeLife/index.vue'
import advancedCropp from '@/components/AdvancedCropped/index.vue'
export default {
    name: 'CreatePatient',
    components: {
        AddEpisodeLife,
        advancedCropp,
        TimeoutSnackbar
    },
    computed: {
        ...mapGetters({
            newPatient: 'patient/newPatient',
            getFlagEditePatientOrNot: 'patient/getFlagEditePatientOrNot',
            apiGuide: 'apiGuide',
            apiUrl: 'apiUrl',
            apiImg: 'apiImg',
            getCroppFlag: 'media/getCroppFlag',
        }),
        returnBirthday() {
            if(this.newPatient.birthday) {
                return new Date(this.newPatient.birthday).toLocaleDateString()
            }

            return ''
        }
    },
    watch: {
        menu (val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        }
    },
    data: () => ({
        errorBirthday: false,
        errorGender: false,
        errorFio: false,
        loadingSavePatient: false,
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        disabled: false,
        editedIndex: null,
        valid: false,
        dialog: false,
        edite: false,
        deleteEpisodeLoading: false,
        activePicker: null,
        menu: false,
        genderList: ['Мужской', 'Женский'],
        listDegreeOfKinship: [],
        listDisease: [],
        objNewAnamnesisFamily: {
            degreeOfKinship: [],
            disease: null
        },
        headers: [
            { text: 'Степень родства', align: 'start', value: 'relations', sortable: true },
            { text: 'Заболевание', align: 'start', value: 'anamnesValueName', sortable: true },
			{ text: 'Действия', value: 'actions', sortable: false }
        ],
		rules: {
			required: v => (!!v || v === 0) || 'Обязательно для заполнения!',
			requiredMultiple: (v) => v.length > 0 || 'Обязательно для заполнения.',
			maxSymbol: (v) => v.length <= 220 || 'Максимум 220 символов.',
		},
    }),
    methods: {
        ...mapMutations({
            savePatient: 'patient/savePatient',
            changeFlag: 'patient/changeFlag',
            setCroppFlag: 'media/setCroppFlag',
            changeTitleEpisode: 'patient/changeTitleEpisode',
            resetToDefaultObjPatient: 'patient/resetToDefaultObjPatient'
        }),
        ...mapActions({
            getEpisode: 'patient/getEpisode',
            getPatient: 'patient/getPatient'
        }),
        showAdd() {
            // console.log('showAdd');
            // this.$emit('showAdd')
            this.changeFlag({ name: 'dialogEpisode', value: true });
            this.changeTitleEpisode({ name: 'titleEpisode', value: 'Добавить эпизод жизни'})
        },
        closeEl() {
            this.resetToDefaultObjPatient();
            this.changeFlag({ name: 'dialog', value: false })
        },
        close() {
            this.dialog = false;
            this.edite = false;
            this.editedIndex = null;
            this.objNewAnamnesisFamily = {
                degreeOfKinship: [],
                disease: null
            }
        },
        saveAnamnesisFam(obj) {
            if(this.$refs.formGroup.validate()) {
                this.savePatient({ name: 'anamnesis', value: {
                    anamnesValueId: obj.disease.id,
                    anamnesValueName: obj.disease.name,
                    relations: obj.degreeOfKinship.map((m) => ({ relationId: m.id, relationName: m.name }))
                }, type: this.edite ? 'edite' : 'add', editedIndex: this.editedIndex});
                this.close()
            } else {
                this.snackbar = { text: 'Заполните обязательные поля!', color: 'warning', timeout: 5000, show: true };
            }
        },
        editeItems(item) {
            this.editedIndex = this.newPatient.anamnesis.indexOf(item);
            this.objNewAnamnesisFamily = Object.assign({}, {
                degreeOfKinship: item.relations.map((m) => ({ id: m.relationId, name: m.relationName })),
                disease: { id: item.anamnesValueId, name: item.anamnesValueName }
            })

            this.edite = true;
            this.dialog = true;

            // console.log(item);
        },
        saveAllPatient(obj) {
            if(this.errorFio || this.errorGender || this.errorBirthday) {
                if(obj.fio) this.errorFio = false
                if(obj.gender) this.errorGender = false
                if(obj.birthday) this.errorBirthday = false
            }

            if(!obj.fio || !obj.gender || !obj.birthday) {
                if(!obj.fio) this.errorFio = true;
                if(!obj.gender) this.errorGender = true;
                if(!obj.birthday) this.errorBirthday = true;

                this.snackbar = { text: 'Заполните обязательные поля!', color: 'warning', timeout: 5000, show: true };
                return;
            }
            this.loadingSavePatient = true
            this.$http.post(`${this.apiUrl}Patient/AddOrUpdate`, {...obj, gender: obj.gender === 'Мужской' ? 0 : 1 })
                .then((res) => {
                    if(res.status === 200)
                        this.resetToDefaultObjPatient();
                        this.loadingSavePatient = false;
                        this.changeFlag({ name: 'dialog', value: false })
                })
                .catch((error) => {
                    if(error) {
                        this.loadingSavePatient = false;
                        this.snackbar = { text: 'Ошибка создания пациента, обратитесь к Администратору!', color: 'error', timeout: 5000, show: true };
                    }
                })
        },
        handleImageUpload(image) {
            this.savePatient({ name: 'logoUrl', value: image, type: 'equally'});
        },
        editeEpisode(item) {
            this.changeTitleEpisode({ name: 'titleEpisode', value: 'Редактировать эпизод жизни'})
            item.editeFlag = true;

            this.getEpisode(item.id)
                .then(() => {
                    item.editeFlag = false;
                    this.changeFlag({ name: 'showData', value: true });
                    this.changeFlag({ name: 'dialogEpisode', value: true });
                })
                .catch((error) => {
                    if(error) {
                        item.editeFlag = false;
                    }
                });
        },
        deleteEpisode(el){
            if (confirm("Вы действительно хотите удалить эпизод жизни?")) {
                this.deleteEpisodeLoading = true
                this.$http.post(`${this.apiUrl}Patient/MarkEpisodeAsDelete?episodeId=${el.id}`)
                .then((res) => {
                    this.getPatient(this.newPatient.id)
                })
                this.deleteEpisodeLoading = false
            }


        }
    },
    created() {
        this.$http.get(`${this.apiGuide}api/SprRelation/GetAll?showDeleted=false`)
            .then((res) => {
                this.listDegreeOfKinship = res.data;
            })
        this.$http.get(`${this.apiGuide}api/SprMkb10/GetAll`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    if(res.data[i].code) {
                        res.data[i].codeName = `${res.data[i].code} - ${res.data[i].name}`
                    }
                }
                this.listDisease = res.data;
            })
    }
}
</script>
